import { Typography } from '@web-chat-core/ui-kit';
import styled from 'styled-components';
import { LogoBlock } from 'ui/components/Logo/view';

export const BadgeWrapper = styled.div`
    box-sizing: border-box;
    height: 40px;
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 12px 12px 14px;
    justify-content: center;
    border-radius: 100px;
    background-color: ${(props) => props.theme.root.colors.theme.themeFirst.primary['10%']};
    border: 1px solid ${(props) => props.theme.root.colors.system['success30%']};

    ${LogoBlock} {
        height: 14px;
    }
`;

export const Separator = styled.div`
    background-color: ${(props) => props.theme.root.colors.accent.textOrIcon};
    width: 1px;
    height: 15px;
`;

export const BadgeLabel = styled(Typography)`
    color: ${(props) => props.theme.root.colors.accent.textOrIcon};
    white-space: nowrap;
`;
